@if ({ alertsLoading: alertsLoading$ | async }; as data) {
  <app-dropdown
    [closeMethod]="closeMethod"
    [title]="'Showing ' + alertCount + ' alerts'"
  >
    @if (data.alertsLoading) {
      <app-loading></app-loading>
    }
    @if (!data.alertsLoading) {
      <div>
        <div class="alert">
          <div class="body" [class.no-alerts]="(alerts$ | async).length == 0">
            @if ({ alerts: alerts$ | async }; as data) {
              @for (alert of data.alerts; track alert) {
                <div
                  class="single-alert"
                  [class.expanded]="alert.expanded"
                  [class.unread]="alert.status.title != 'Shown'"
                >
                  <div class="alert-top-row">
                    <div class="title">
                      @if (alert.status.title != "Shown") {
                        <div class="unread-bubble"></div>
                      }
                      <div>{{ alert.title }}</div>
                    </div>
                    <div class="last-triggered">
                      {{
                        alertService.formatTimestampToNow(
                          alert.last_triggered_timestamp * 1000
                        )
                      }}
                    </div>
                    <div
                      class="see-more-holder"
                      (click)="toggleExpandAlert(alert.id)"
                    >
                      <div>
                        {{
                          !alert.expanded
                            ? ("dropdown-alerts.button.show-more" | translate)
                            : ("dropdown-alerts.button.show-less" | translate)
                        }}
                      </div>
                      <div class="see-more-chevron">
                        <fa-icon
                          class="toggle-chevron"
                          [icon]="['fas', 'angle-down']"
                        ></fa-icon>
                      </div>
                    </div>
                  </div>
                  @if (alert.expanded) {
                    <div class="alert-expandable">
                      <div class="expandable-group">
                        <div class="expandable-key">
                          <div>
                            {{ "dropdown-alerts.title.on-object" | translate }}
                          </div>
                        </div>
                        <div class="expandable-value">
                          <a
                            [href]="
                              'analytics/workspace/' +
                              alert.workspace_id +
                              '/feed/' +
                              alert['feed_id']
                            "
                            >{{ alert.feed_title }}</a
                          >
                        </div>
                      </div>
                      <div class="expandable-group">
                        <div class="expandable-key">
                          <div>
                            {{ "dropdown-alerts.title.triggered" | translate }}
                          </div>
                        </div>
                        <div class="expandable-value">
                          {{
                            alert.last_triggered_timestamp * 1000
                              | date: "dd.MM.yyyy HH:mm"
                          }}
                        </div>
                      </div>
                      <div class="expandable-group">
                        <div class="expandable-key">
                          <div>
                            {{ "dropdown-alerts.title.condition" | translate }}
                          </div>
                        </div>
                        <div class="expandable-value">
                          {{ alert.trigger_type.title }}
                        </div>
                      </div>
                      <div class="expandable-group">
                        <div class="expandable-key">
                          <div>
                            {{ "dropdown-alerts.title.created-on" | translate }}
                          </div>
                        </div>
                        <div class="expandable-value">
                          {{
                            alert.time_created.timestamp * 1000
                              | date: "dd.MM.yyyy HH:mm"
                          }}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            }
            @if ((alerts$ | async).length == 0) {
              <div class="no-alerts">
                {{ "dropdown-alerts.message.no-alerts" | translate }}
              </div>
            }
          </div>
        </div>
      </div>
    }
  </app-dropdown>
}
